
import "core-js/stable";

import { createApp } from "vue";
import { GoogleMap, Marker, AdvancedMarker, InfoWindow } from "vue3-google-map";
import VueComponentRegistery from "./utils/vue-component-registry";
import { vMask } from "./utils/input-mask";
import MaskedInput from "./utils/MaskedInput";
import AnimatedNumber from "./components/AnimatedNumber.vue";
import { mqPlugin } from "./utils/breakpoints";
import clickOutside from './global/directives/clickoutside';
import { googleMapsPlugin } from './plugins/google-maps';

const app = createApp({});
app.use(mqPlugin);
app.use(googleMapsPlugin);

app.component('GoogleMap', GoogleMap);
app.component('Marker', Marker);
app.component('AdvancedMarker', AdvancedMarker);
app.component('InfoWindow', InfoWindow);
app.component('MaskedInput', MaskedInput);
app.component('masked-input', MaskedInput);
app.component('AnimatedNumber', AnimatedNumber);

app.directive('mask', vMask);
app.directive('click-outside', clickOutside);
import LocationSearch from './location-search/src/index.vue';
import LocationSearchStore from"./location-search/src/store";
VueComponentRegistery.register("location-search", LocationSearch, LocationSearchStore);

import LocationSearchBlock from './location-search-block/src/index.vue';
import LocationSearchBlockStore from"./location-search-block/src/store";
VueComponentRegistery.register("location-search-block", LocationSearchBlock, LocationSearchBlockStore);


import AdvisorSearch from './advisor-search/src/index.vue';
import AdvisorSearchStore from"./advisor-search/src/store";
VueComponentRegistery.register("advisor-search", AdvisorSearch, AdvisorSearchStore);

import FeaturedSearch from './featured-search/src/index.vue';
import FeaturedSearchStore from "./featured-search/src/store";
VueComponentRegistery.register("featured-search", FeaturedSearch, FeaturedSearchStore);

import CDRateCalculator from './cd-rate-calculator/src/index.vue';
import CDRateCalculatorStore from "./cd-rate-calculator/src/store";
VueComponentRegistery.register("cd-rate-calculator", CDRateCalculator, CDRateCalculatorStore);

import MortgageRateCalculator from './mortgage-rate-calculator/src/index.vue';
import MortgageRateCalculatorStore from "./mortgage-rate-calculator/src/store";
VueComponentRegistery.register("mortgage-rate-calculator", MortgageRateCalculator, MortgageRateCalculatorStore);

import MoneyMarketCalculator from './money-market-calculator/src/index.vue';
import MoneyMarketCalculatorStore from "./money-market-calculator/src/store";
VueComponentRegistery.register("money-market-calculator", MoneyMarketCalculator, MoneyMarketCalculatorStore);


import ZipcodeIdentifier from './zipcode-identifier/src/index.vue';
VueComponentRegistery.register("zipcode-identifier", ZipcodeIdentifier);

const appElement = document.getElementById('app');
if (appElement) {
    app.mount("#app");
}
